import { render, staticRenderFns } from "./supervisor.vue?vue&type=template&id=448b58b0&scoped=true"
import script from "./supervisor.vue?vue&type=script&lang=js"
export * from "./supervisor.vue?vue&type=script&lang=js"
import style0 from "./supervisor.vue?vue&type=style&index=0&id=448b58b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b58b0",
  null
  
)

export default component.exports